<template>
  <ol class="printer-document-content-block__list">
    <li v-for="item in block.value" :key="item">{{ item }}</li>
  </ol>
</template>

<script>
import { PrinterDocumentContentBlock } from '@/models/client/PrinterDocumentContentBlock.model';

export default {
  name: 'PrinterDocumentContentBlockList',
  props: {
    block: [PrinterDocumentContentBlock, Object],
  },
};
</script>

<style lang="scss" src="./index.scss"></style>
